import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Checkbox, CheckboxProps } from 'tea-component';

interface IShowTopCountriesCheckboxProps extends CheckboxProps {
  num?: number;
}

const ShowTopCountriesCheckbox: React.FC<IShowTopCountriesCheckboxProps> = (props) => {
  const { className, num = 3, value, onChange, ...restProps } = props;

  const { formatMessage } = useIntl();

  return (
    <Checkbox
      {...restProps}
      className={classnames('dbi-common-checkbox dbi-show-top_countries-checkbox search-item', className)}
      display="inline"
      value={value}
      onChange={onChange}
    >
      {formatMessage({ id: 'dbi_compare_show_top_countries' }, { num })}
    </Checkbox>
  );
};

export default ShowTopCountriesCheckbox;
